import { useCallback, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Icon } from './Icon.jsx';
import { useT } from '../i18n/index.js';

export function Dropzone({ onFile }) {
  const t = useT();
  const [hover, setHover] = useState(false);
  const inputRef = useRef(null);

  const handleFiles = useCallback(
    (files) => {
      const file = Array.from(files || []).find(
        (f) => f.type === 'application/pdf' || f.name.toLowerCase().endsWith('.pdf')
      );
      if (file) onFile(file);
    },
    [onFile]
  );

  const onDrop = (e) => {
    e.preventDefault();
    setHover(false);
    handleFiles(e.dataTransfer.files);
  };

  return (
    <div className="dropzone">
      <motion.div
        className={`dropzone-card ${hover ? 'hover' : ''}`}
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.32, ease: [0.2, 0.7, 0.2, 1] }}
        onDragEnter={(e) => { e.preventDefault(); setHover(true); }}
        onDragOver={(e) => { e.preventDefault(); setHover(true); }}
        onDragLeave={() => setHover(false)}
        onDrop={onDrop}
        onClick={() => inputRef.current?.click()}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') inputRef.current?.click(); }}
      >
        <div className="dropzone-icon">
          <Icon name="upload" size={28} stroke={2} style={{ color: '#0b0d12' }} />
        </div>
        <h2>{t('dropzone.title')}</h2>
        <p>{t('dropzone.subtitle')}</p>
        <div className="dropzone-formats">
          <span className="chip">.pdf</span>
          <span className="chip">{t('dropzone.size')}</span>
          <span className="chip">{t('dropzone.local')}</span>
        </div>
        <input
          ref={inputRef}
          type="file"
          accept="application/pdf,.pdf"
          className="sr-only"
          aria-label={t('dropzone.title')}
          onChange={(e) => handleFiles(e.target.files)}
        />
      </motion.div>
    </div>
  );
}
